import * as z from 'zod';
import { schema } from '@forms/helpers';
import { DocumentsQueryType } from '@services/documents';
import { FileFormValues } from './types';

export const formSchema = (queryType: DocumentsQueryType) =>
  z.object({
    subtaskId: schema.input({ name: 'documentType', required: true }),
    name: z.custom<string>((val) => {
      const select = document.querySelector('[name="subtaskIdSelect"]') as HTMLSelectElement;
      if (queryType === 'foreman' || select?.value === 'other') return val;
      return true;
    }, 'documentName.required'),
  });

export const defaultValues: FileFormValues = {
  subtaskId: '',
  name: '',
};
